const GENERATED_BASE = '/category-landing-assets/generated'

function generatedImage(fileName, label, description) {
  return {
    fileId: `${GENERATED_BASE}/${fileName}`,
    label,
    description,
  }
}

const CATEGORY_HERO_IMAGE_OPTIONS = {
  HIDDEN_INSURANCE_MONEY: [
    generatedImage('hidden-insurance-money-financial-desk.png', '전문 상담 데스크', '실사형 금융 상담 분위기'),
    generatedImage('hidden-insurance-money-abstract-blue.jpg', '차분한 확인형', '문구를 얹기 쉬운 블루 추상 이미지'),
    generatedImage('hidden-insurance-money-document-flow-navy.jpg', '서류 확인 플로우', '보험금 확인 과정을 깔끔하게 표현'),
    generatedImage('hidden-insurance-money-soft-claim-check.jpg', '부드러운 청구 체크', '숨은 보험금 조회에 맞춘 신뢰형 이미지'),
  ],
  COVERAGE_ANALYSIS: [
    generatedImage('coverage-analysis-dashboard-blue.jpg', '분석 대시보드형', '보장 구조 점검에 어울리는 이미지'),
    generatedImage('coverage-analysis-protection-map-teal.jpg', '보장 지도형', '여러 보장을 연결해 보여주는 이미지'),
    generatedImage('coverage-analysis-report-cards-sky.jpg', '리포트 카드형', '상담 리포트와 점검 결과를 강조'),
  ],
  INSURANCE_REMODELING: [
    generatedImage('insurance-remodeling-renewal-green.jpg', '재정비·성장형', '리모델링과 개선 흐름을 표현'),
    generatedImage('insurance-remodeling-before-after-sage.jpg', '전후 비교형', '기존 보장과 개선 방향을 비교하는 톤'),
    generatedImage('insurance-remodeling-plan-refresh.jpg', '플랜 새로고침형', '보험 점검 후 재설계를 안내하는 이미지'),
  ],
  PRODUCT_AUTO: [
    generatedImage('product-auto-route-blue.jpg', '차량 보장형', '자동차보험 전용 이미지'),
    generatedImage('product-auto-road-safety-cyan.jpg', '안전 주행형', '도로와 안전 보장 이미지를 결합'),
    generatedImage('product-auto-night-route-navy.jpg', '야간 경로형', '차분한 네이비 톤의 자동차보험 이미지'),
  ],
  PRODUCT_COMPREHENSIVE: [
    generatedImage('product-comprehensive-protection-navy.jpg', '종합 보호형', '여러 보장을 통합해 보여주는 이미지'),
    generatedImage('product-comprehensive-layered-shield.jpg', '겹겹 보호형', '다층 보장과 통합 관리를 표현'),
    generatedImage('product-comprehensive-family-cover.jpg', '가족 통합 보장형', '가족과 보장 영역을 함께 강조'),
  ],
  PRODUCT_PENSION: [
    generatedImage('product-pension-retirement-warm.jpg', '미래 준비형', '장기 계획과 은퇴 준비 톤'),
    generatedImage('product-pension-retirement-path-gold.jpg', '은퇴 경로형', '장기 목표와 노후 준비를 표현'),
    generatedImage('product-pension-long-plan-olive.jpg', '장기 플랜형', '차분한 올리브 톤의 연금 준비 이미지'),
  ],
  PRODUCT_WHOLE_LIFE: [
    generatedImage('product-whole-life-family-slate.jpg', '가족 보호형', '종신보험의 보호 목적에 맞춘 이미지'),
    generatedImage('product-whole-life-legacy-home.jpg', '가정 승계형', '가족과 자산 보호 메시지에 적합'),
    generatedImage('product-whole-life-family-continuity.jpg', '가족 연속성형', '장기적인 가족 보호 이미지를 강조'),
  ],
  PRODUCT_CARE: [
    generatedImage('product-care-support-rose.jpg', '돌봄 지원형', '간병·가족 지원 분위기'),
    generatedImage('product-care-caregiver-calendar.jpg', '돌봄 일정형', '간병과 지속적인 돌봄 관리를 표현'),
    generatedImage('product-care-medical-support-soft.jpg', '의료 지원형', '부드러운 상담·지원 톤의 이미지'),
  ],
  PRODUCT_FIRE: [
    generatedImage('product-fire-property-orange.jpg', '재산 보호형', '화재보험·건물 보호 이미지'),
    generatedImage('product-fire-building-protection.jpg', '건물 보호형', '사업장과 건물 안전을 강조'),
    generatedImage('product-fire-property-safety-plan.jpg', '안전 설계형', '재산 보호와 리스크 관리를 표현'),
  ],
  PERSONAL_INTRO: [
    generatedImage('personal-intro-advisor-neutral.jpg', '전문가 소개형', '개인 브랜딩과 상담 전문성 표현'),
    generatedImage('personal-intro-consulting-desk-blue.jpg', '상담 데스크형', '상담 전문성과 신뢰감을 강조'),
    generatedImage('personal-intro-trust-network.jpg', '신뢰 네트워크형', '고객 연결과 관계 중심 이미지를 표현'),
  ],
}

const LEGACY_CATEGORY_HERO_IMAGES = {
  HIDDEN_INSURANCE_MONEY: '/category-landing-assets/hidden-insurance-money-hero.svg',
  COVERAGE_ANALYSIS: '/category-landing-assets/coverage-analysis-hero.svg',
  INSURANCE_REMODELING: '/category-landing-assets/insurance-remodeling-hero.svg',
  PRODUCT_AUTO: '/category-landing-assets/product-auto-hero.svg',
  PRODUCT_COMPREHENSIVE: '/category-landing-assets/product-comprehensive-hero.svg',
  PRODUCT_PENSION: '/category-landing-assets/product-pension-hero.svg',
  PRODUCT_WHOLE_LIFE: '/category-landing-assets/product-whole-life-hero.svg',
  PRODUCT_CARE: '/category-landing-assets/product-care-hero.svg',
  PRODUCT_FIRE: '/category-landing-assets/product-fire-hero.svg',
  PERSONAL_INTRO: '/category-landing-assets/personal-intro-hero.svg',
}

export function getCategoryLandingHeroImage(category) {
  const key = String(category || '').trim()
  return CATEGORY_HERO_IMAGE_OPTIONS[key]?.[0]?.fileId || LEGACY_CATEGORY_HERO_IMAGES[key] || ''
}

export function getCategoryLandingHeroImageOptions(category) {
  const key = String(category || '').trim()
  const generated = CATEGORY_HERO_IMAGE_OPTIONS[key] || []
  const legacy = LEGACY_CATEGORY_HERO_IMAGES[key]
    ? [{
        fileId: LEGACY_CATEGORY_HERO_IMAGES[key],
        label: '기존 일러스트',
        description: '기존 기본 제공 이미지',
      }]
    : []
  return [...generated, ...legacy]
}
